import gql from 'graphql-tag';

import { CatchFieldsForPostsViewer } from './fragments/CatchFieldsForPostsViewer';
import { CatchFragments } from './fragments/CatchType';
import { ImageFragments } from './fragments/ImageType';
import { PageFragments } from './fragments/PageType';
import { PostCardFragment, PostFragments } from './fragments/PostType';
import { UserFragments } from './fragments/UserType';

export const getSinglePageName = gql`
  query GetSinglePageName($id: Int!) {
    entry: page(id: $id) {
      ...PageId
      displayName
      externalId
    }
  }
  ${PageFragments.id}
`;

export const getPage = gql`
  query GetPage($id: String!) {
    entry: page(externalId: $id) {
      ...PageId
      displayName
      published
      logo(croppingStrategy: CENTER, height: 128, width: 128) {
        ...ImageFields
      }
      coverImages(width: 1024, first: 1) {
        edges {
          node {
            ...ImageFields
          }
        }
      }
      posts(filters: { havingVideo: true, topLevel: true }, first: 3) {
        edges {
          node {
            ...PostCardFields
          }
        }
      }
      followedByCurrentUser
      followers {
        totalCount
      }
      promotedCallToActions(first: 1) {
        edges {
          node {
            id
            headline
            subHeadline
            buttonText
            targetUrl
            image {
              url
              width
              height
            }
          }
        }
      }
      description
      pageable {
        ... on Brand {
          url
        }
      }
      resources(first: 100) {
        edges {
          node {
            label
            position
          }
        }
      }
    }
  }
  ${ImageFragments.imageFields}
  ${PageFragments.id}
  ${PostCardFragment}
`;

export const getPageCatches = gql`
  query GetPageCatches($id: String!) {
    entry: page(externalId: $id) {
      ...PageId
      catches(last: 12) {
        edges {
          node {
            ...CatchMetadata
            ...CatchFieldsForPostsViewer
          }
        }
      }
    }
  }
  ${CatchFragments.metadata}
  ${PageFragments.id}
  ${PostFragments.id}
  ${CatchFieldsForPostsViewer}
`;

export const getPagePosts = gql`
  query GetPagePosts($id: String!, $after: String) {
    entry: page(externalId: $id) {
      ...PageId
      posts(first: 12, after: $after) {
        edges {
          node {
            ...PostId
            publishedAt
            sharingPost
            catch {
              ...CatchId
              ...CatchFishingWaterName
              ...CatchSpeciesName
            }
            comments {
              totalCount
            }
            createdAt
            displayProductUnits {
              totalCount
            }
            ...PostDisplayEntities
            ...PostProductUnits
            ...PostVideoFields
            images(first: 10, croppingStrategy: SMART, height: 400, width: 400) {
              totalCount
              edges {
                node {
                  ...ImageFields
                }
              }
            }
            likedByCurrentUser
            likesCount
            text {
              text
            }
            user {
              ...UserId
              ...UserAvatar
              nickname
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${CatchFragments.id}
  ${PageFragments.id}
  ${PostFragments.id}
  ${CatchFragments.fishingWaterName}
  ${CatchFragments.speciesName}
  ${PostFragments.productUnits}
  ${PostFragments.displayEntities}
  ${PostFragments.videoFields}
  ${ImageFragments.imageFields}
  ${UserFragments.id}
  ${UserFragments.avatar}
`;
